import LocaleKeys from '../locales/keys';
export const menus = [
  {
    Value: 1,
    name: `${LocaleKeys.orderHistory.last30Days}`,
  },
  {
    Value: 6,
    name: `${LocaleKeys.orderHistory.past6Months}`,
  },
  {
    Value: 12,
    name: `${LocaleKeys.orderHistory.past12Months}`,
  },
  {
    Value: -1,
    name: `${LocaleKeys.orderHistory.all}`,
  },
];
